<template>
  <div id='design-portfolio-suggestions-header' class='px-5 py-3'>
      <h2 class='title'>Top Alternatives</h2>

      <p class='note'>
        For each style category, any fund listed in green will be fund with superior values and historical financial metrics based on your selections.
      </p>
      
      <div class='buttons'>
        <a
          v-if='saveLink'
          class='button is-medium'
          :href='saveLink'
          target='_blank'
          rel='noreferrer noopener'>
          Save Portfolio
        </a>
        
        <a
          v-if='reportLink'
          class='button is-medium is-primary'
          :href='reportLink'
          target='_blank'
          rel='noreferrer noopener'>
          View Impact Report
        </a>
      </div>
  </div>
</template>



<script>
  //import SubComponent from '../components/SubComponent'

  export default {
      name: 'component-name',
      components: { /* Subcomponents */ },
      props: ['links'],
      data() { return { /* Local variables */ }},
      beforeCreate() {},
      created() {},
      mounted() {},
      updated() {},
      computed: {
        saveLink() {
          if(!this.links) return null
          const  slug = this.links.slug
          return slug ? '/advisordashboard/model_portfolio_create/?update=' + slug : null
        },
        reportLink() {
          if(!this.links) return null
          const  id = this.links.id
          return id ? '/ui/advisor/reports/?reportType=impact&reportStyle=minimal_relative&reporting=' + id: null
        }
      },
      watch: { /*
          Watches an existing property
          Only runs when the watched property changes */
      },
      methods: {
        SaveAlerts: function(evt) {
          this.$buefy.toast.open('Alerts saved for these metrics!');
        },
      }
  }
</script>



<style scoped>
  #design-portfolio-suggestions-header {
    display:     flex;
    align-items: center;
    width:       100%;
  }

  .title, .buttons {
    flex-basis: 10%;
    flex-grow:  1;
  }

  .buttons {
    justify-content: flex-end;
  }
  
  .note {
    max-width: 30rem;
  }
</style>